import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const orderApi = {
  create(params) {
    return http.post(API_URLS.ORDER_LIMIT, {params});
  },
  createV2(params) {
    return http.post(API_URLS.G_ORDER, {params});
  },
  modify(o) {
    const {type, ...params} = o;
    return http.put(type === 'PerpetualV2' ? API_URLS.G_ORDER_MODIFY : API_URLS.ORDER_MODIFY, {params});
  },
  cancel(o) {
    const {type, ...query} = o;
    return http.delete(type === 'PerpetualV2' ? API_URLS.G_ORDER_CANCEL : API_URLS.ORDER_CANCEL, {query});
  },
  cancelAll(query) {
    return http.delete(API_URLS.G_ORDER_CANCEL_ALL, {query});
  },
  closeAllPositions(params?) {
    return http.post(API_URLS.POSITION_CLOSE_ALL, {params});
  },
  getTradingList(o) {
    const {type, ...query} = o;
    return http.get(type === 'PerpetualV2' ? API_URLS.CONTRACT_TRADING_LIST_V2 : API_URLS.CONTRACT_TRADING_LIST, {query});
  },
  scaledPreview(query) {
    return http.get(API_URLS.SCALED_PREVIEW, {query});
  },
  createScaledOrder(parameter) {
    const {type, ...params} = parameter;
    return http.post(type === 'Perpetual' ? API_URLS.SCALED_ORDERS : API_URLS.SCALED_G_ORDERS, {params});
  },
  createBasketOrder(params) {
    return http.post(API_URLS.G_ORDERS_BASKET, {params});
  },
  createOrderList(params) {
    return http.post(API_URLS.G_ORDER_LIST, {params});
  },
  createForAirPosTpSl(params) {
    return http.post(API_URLS.STRATEGY_AIR_POS_TPSL_CREATE, {params});
  },
  updateForAirPosTpSl(params) {
    return http.post(API_URLS.STRATEGY_AIR_POS_TPSL_REPLACE, {params});
  },
  cancelForAirPosTpSl(query) {
    return http.delete(API_URLS.STRATEGY_AIR_POS_TPSL_CANCEL, {query});
  },
};
